import anime from 'animejs';
import { Component } from 'nospa';

const ITEM_ACTIVE_CLASSNAME = '_active';

export default class Spoiler extends Component {
  onInit() {
    this.buttonRef = this.$getRef('button');
    this.contentRef = this.$getRef('content');
    this.isExpanded = this.$el.classList.contains(ITEM_ACTIVE_CLASSNAME);

    if (this.isExpanded) {
      this.expand(true);
    } else {
      this.collapse(true);
    }

    this.toggleItem = this.toggleItem.bind(this);

    this.setEvents();
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';

    if (this.buttonRef) {
      this.buttonRef.el[action]('click', this.toggleItem);
    }
  }

  expand(immediate) {
    if (!this.contentRef) return;
    anime.remove(this.contentRef.el);

    this.contentRef.el.style.display = 'block';

    anime({
      targets: this.contentRef.el,
      height: (el) => el.scrollHeight,
      duration: immediate ? 0 : 500,
      easing: 'easeOutCubic',
    });

    this.$el.classList.add(ITEM_ACTIVE_CLASSNAME);
    this.isExpanded = true;
  }

  collapse(immediate) {
    if (!this.contentRef) return;
    anime.remove(this.contentRef.el);

    anime({
      targets: this.contentRef.el,
      height: 0,
      duration: immediate ? 0 : 300,
      easing: 'easeInQuad',
      complete: () => {
        this.contentRef.el.style.display = 'none';
      },
    });

    this.$el.classList.remove(ITEM_ACTIVE_CLASSNAME);
    this.isExpanded = false;
  }

  toggleItem() {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  onDestroy() {
    this.setEvents(false);
  }
}
